import { render } from "./Prova.vue?vue&type=template&id=5da7aa88"
import script from "@/assets/js/prova.js?vue&type=script&lang=js"
export * from "@/assets/js/prova.js?vue&type=script&lang=js"

import "./Prova.vue?vue&type=style&index=0&id=5da7aa88&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__